import React from 'react';
import { Typography } from 'antd';
import { format, parseISO } from 'date-fns';

export const formatTime = (dateString) => {
    if (!dateString) return '';
    return format(parseISO(dateString), 'HH:mm');
};

export const formatFullTime = (dateString, locale) => {
    if (!dateString) return '';

    if (locale) {
        return new Intl.DateTimeFormat(locale, {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }).format(parseISO(dateString));
    }

    return format(parseISO(dateString), 'PPpp');
};

export const formatDuration = (seconds) => {
    if (typeof seconds !== 'number' || Number.isNaN(seconds)) return '';
    const total = Math.floor(seconds);
    const mins = Math.floor(total / 60);
    const secs = total % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
};

const { Text } = Typography;

export const renderTextWithLinks = (text, isAgentOrSupport, isDarkMode) => {
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlPattern);
    // Ensure links are clearly distinct from surrounding text.
    // - Right-side (primary) bubbles: always gold for strong contrast
    // - Left-side bubbles: blue in light mode, gold in dark mode
    const linkColor = isAgentOrSupport ? '#FFD700' : (isDarkMode ? '#FFD700' : '#1890ff');

    return parts.map((part, index) => {
        if (part.match(urlPattern)) {
            return (
                <Text
                    key={index}
                    style={{
                        color: isAgentOrSupport ? linkColor : '#1890ff',
                        textDecoration: 'underline',

                        cursor: 'pointer',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        fontSize: '13px',
                        fontWeight: 600
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        window.open(part, '_blank');
                    }}
                >
                    {part}
                </Text>
            );
        }
        return (
            <Text
                key={index}
                style={{
                    color: (isAgentOrSupport && isDarkMode) ? '#fff' : (isAgentOrSupport && !isDarkMode) ? 'inherit' : 'inherit',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontSize: '13px'
                }}
            >
                {part}
            </Text>
        );
    });
};
